import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-all-landing',
  styleUrls: [],
  template: `
    <div class="prelogin-all-imgcontainer">
    </div>`
})
export class AllLandingComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle(environment.allPageTitle);
  }

}
